import { gql } from '@apollo/client'
import {
  CollectionGridBlockFragment,
  FeaturedOfferBlockFragment,
  OfferGridBlockFragment,
} from 'app/features/offer/blocks'
import {
  BaseBlock,
  ButtonBlockFragment,
  ColumnLayoutBlockFragment,
  FaqsBlockFragment,
  FeaturedContentCarouselBlockFragment,
  HeadingBlockFragment,
  HtmlBlockFragment,
  ImageBlockFragment,
  JumpToLinksBlockFragment,
  ReferFriendBlockFragment,
  RichTextBlockFragment,
  ShareLinkBlockFragment,
  SpacerBlockFragment,
} from 'app/features/shared/blocks'
import { VideoBlockFragment } from 'app/features/shared/blocks/video-block'
import { usePersistedCacheQuery } from 'app/hooks'

export const fetchArticleQuery = gql`
  query fetchArticle($slug: String!, $draft: Boolean!) {
    Articles(where: { slug: { equals: $slug } }, draft: $draft) {
      docs {
        id
        title
        primaryCategory {
          name
          slug
        }
        featuredImage {
          url
          alt
        }
        content {
          ${ButtonBlockFragment.partialFragment}
          ${CollectionGridBlockFragment.partialFragment}
          ${ColumnLayoutBlockFragment.partialFragment}
          ${FaqsBlockFragment.partialFragment}
          ${FeaturedContentCarouselBlockFragment.partialFragment}
          ${FeaturedOfferBlockFragment.partialFragment}
          ${HeadingBlockFragment.partialFragment}
          ${HtmlBlockFragment.partialFragment}
          ${ImageBlockFragment.partialFragment}
          ${JumpToLinksBlockFragment.partialFragment}
          ${OfferGridBlockFragment.partialFragment}
          ${ReferFriendBlockFragment.partialFragment}
          ${RichTextBlockFragment.partialFragment}
          ${ShareLinkBlockFragment.partialFragment}
          ${SpacerBlockFragment.partialFragment}
          ${VideoBlockFragment.partialFragment}
        }
        slug
        updatedAt
        meta {
          title
          description
        }
      }
    }
  }
`

export interface ArticleQueryInput {
  slug: string
  draft: boolean
}

export interface ArticleQueryOutput {
  Articles: {
    docs: {
      id: string
      title: string
      primaryCategory: {
        name: string
        slug: string
      }
      featuredImage: {
        url: string
        alt: string
      }
      content: BaseBlock[]
      slug: string
      updatedAt: string
      meta: {
        title?: string
        description?: string
      }
    }[]
  }
}

export const useArticleQuery = (input: ArticleQueryInput) =>
  usePersistedCacheQuery<ArticleQueryOutput, ArticleQueryInput>(fetchArticleQuery, {
    variables: input,
  })
